import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SkillCard from './SkillCard';
import './Skills.css';

function Skills() {
  const [activeTab, setActiveTab] = useState('frontend'); // Default active tab
  const [skillsData, setSkillsData] = useState({}); // To hold all skills data
  const [categories, setCategories] = useState([]); // To hold skill category names

  useEffect(() => {
    // Fetch data using Axios
    axios.get('/data/data.json')
      .then((response) => {
        setSkillsData(response.data.skills); // Accessing 'skills' from the data
        setCategories(Object.keys(response.data.skills)); // Extract category names dynamically
        setActiveTab(Object.keys(response.data.skills)[0]); // Set the first category as the active tab by default
      })
      .catch((error) => {
        console.error('Error fetching skills data:', error);
      });
  }, []);

  const handleTabClick = (target) => {
    setActiveTab(target);
  };

  if (!skillsData) {
    return <div style={{textAlign: 'center'}}>Loading Skills...</div>; // Loading state until the data is fetched
  }

  return (
    <section className="skills section" id="skills">
      <h2 data-heading="My Abilities" className="section__title">My Experience</h2>

      <div className="skills__container container grid">
        {/* Dynamically render skill tabs */}
        <div className="skills__tabs">
          {categories.map((category) => (
            <div
              key={category}
              className={`skills__header ${activeTab === category ? 'skills__active' : ''}`}
              onClick={() => handleTabClick(category)}
            >
              <i className={`uil ${category === 'frontend' ? 'uil-brackets-curly' : category === 'backend' ? 'uil-swatchbook' : category === 'coding' ? 'uil-server-network' : category === 'devops' ? 'uil-chart-line' : 'uil-cell'} skills__icon`}></i>
              <div>
                <h1 className="skills__title">{category.charAt(0).toUpperCase() + category.slice(1)}</h1>
                <span className="skills__subtitle">{skillsData[category].yearsOfExperience}</span>
              </div>
              <i className="uil uil-angle-down skills__arrow"></i>
            </div>
          ))}
        </div>

        {/* Dynamically render skill content based on the active tab */}
        <div className="skills__content">
          {categories.map((category) => (
            activeTab === category && (
              <div key={category} className="skills__group skills__active">
                <div className="skills__list grid">
                  {skillsData[category].skills.map((skill, index) => (
                    <SkillCard key={index} name={skill.name} percentage={skill.percentage} />
                  ))}
                </div>
              </div>
            )
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
